export class HUDLayer {
  readonly element: HTMLElement;

  constructor() {
    this.element = document.createElement('div');
    this.element.className = 'hud-layer';

    const title = document.createElement('div');
    title.className = 'hud-corner hud-top-left';
    title.textContent = 'STARFALL FACTIONS';

    const version = document.createElement('div');
    version.className = 'hud-corner hud-bottom-left';
    version.textContent = 'v0.5.0 — mouse flight';

    const controls = document.createElement('div');
    controls.className = 'hud-controls hud-corner hud-bottom-right';
    controls.innerHTML = [
      '<span><kbd>Mouse</kbd> aim</span>',
      '<span><kbd>W</kbd><kbd>S</kbd> throttle</span>',
      '<span><kbd>A</kbd><kbd>D</kbd> roll</span>',
      '<span><kbd>LMB</kbd> fire</span>',
      '<span><kbd>E</kbd> interact</span>'
    ].join('');

    this.element.append(title, version, controls);
  }
}
